var React = require('react');

function IcoCollapse (props) {
    return React.createElement("svg",props,React.createElement("image",{"width":"14","height":"8","xlinkHref":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAMAAAD+zz7+AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAARVBMVEX///9Ci8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8oAAABsn33jAAAAFXRSTlMAjO03HNi6gPHctAOlyQ4PJOTlk6u1/yiwAAAAAWJLR0QWfNGoGQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+EDDg00CuWU5t4AAAA+SURBVAjXY2BkYmaAAhZWNgZ2UQ4on4VTlIuBmwfKB/J4+RhgfBCPHyQM5gsIQnkQvhCcB+Yj8YB8YREIDwCkRgLw0faeUQAAAABJRU5ErkJggg=="}));
}

IcoCollapse.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8"};

module.exports = IcoCollapse;

IcoCollapse.default = IcoCollapse;
